import { render, staticRenderFns } from "./AccessDeniedView.vue?vue&type=template&id=c41a01a0&scoped=true"
import script from "./AccessDeniedView.vue?vue&type=script&lang=js"
export * from "./AccessDeniedView.vue?vue&type=script&lang=js"
import style0 from "./AccessDeniedView.vue?vue&type=style&index=0&id=c41a01a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41a01a0",
  null
  
)

export default component.exports